/* eslint-disable import/prefer-default-export */
export const SERVICE_HEADER_TRIGGER_ID = 'service-header-trigger';
